module.exports = __webpack_public_path__ + "static/media/foto_2.e0b799f3.png";